import { StepperSetupStepStatus } from '../../types';

export const CLASS_NAMES = {
	stepCard:
		'relative overflow-hidden rounded-lg bg-white shadow-none rounded-xl',
	stepCardContent: 'transition-[filter,opacity] duration-300',
	stepCardContentDimmed: 'opacity-30 blur-[8px]',
	stepHeader: 'flex w-full items-center gap-3 px-6 py-4 text-left ',
	stepIconCompleted:
		'flex h-[21px] w-[21px] shrink-0 items-center justify-center rounded-full text-[#0AAF58]',
	stepIconLocked:
		'flex h-[21px] w-[21px] shrink-0 items-center justify-center text-[#7F8DA3]',
	stepNumber:
		'flex h-[21px] w-[21px] items-center justify-center rounded-full bg-[#8FA0B5] text-white',
	stepTitle: 'text-xl font-extrabold leading-5 text-[var(--color-primary-900)]',
	stepTitleDisabled: 'text-[#7F8DA3]',
	stepTitleByStatus: {
		[StepperSetupStepStatus.Active]: 'text-[var(--color-primary-900)]',
		[StepperSetupStepStatus.Completed]: 'text-[#0AAF58]',
		[StepperSetupStepStatus.Upcoming]: 'text-[var(--color-primary-900)]'
	}
} as const;
